import React, { FunctionComponent } from 'react';
import University from '../../../../networking/models/University';
import UniversityCard from '../../../utils/UniversityCard';
import {AnimatePresence, motion} from 'framer-motion';

interface Props {
    universities: University[];
    refreshKey?: string;
    selectedUniversities?: number[];
    onCompareClick?: (university: University) => void;
}

const UniversityList: FunctionComponent<Props> = React.memo(({ universities, refreshKey, selectedUniversities, onCompareClick }) => {

    const variants = {
        initial: {
            opacity: 0,
        },
        enter: {
            opacity: 1
        },
        exit: {
            opacity: 0,
            transition: {
                duration: .1,
                ease: 'easeInOut'
            }
        }
    };

    return (
        <AnimatePresence mode={'wait'}>
            <motion.div variants={variants} initial={'initial'} animate={'enter'} exit={'exit'} key={refreshKey}>
                { universities.map(university => (
                    <UniversityCard
                        university={university}
                        onCompareClick={onCompareClick}
                        selected={selectedUniversities?.includes(university.id!) ?? false}
                        key={university.id} />
                )) }
            </motion.div>
        </AnimatePresence>
    );
});

export default UniversityList;
